<template>
    <div>
        <div class="sidebar-wrapper">
            <SideNav />
        </div>
        <div class="p-3">
            <div class="p-4 mt-2">
                <h4 class="title is-4 mb-1"> {{ getUser.name }} </h4>
                <h6 class="is-5 mb-2 has-text-weight- has-text-grey is-7">{{ getUser.phone.countryCode+getUser.phone.tel }}</h6>
                <b-tag type="is-primary"> {{ getUser.type }} </b-tag>
            </div>
            <div class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-4 has-text-primary"> Earnings </p>
                            <h4 class="subtitle is-5 mb-0">Total orders </h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right">
                            <h4 class="has-text-weight-medium title is-6 "> {{ numFormat(getTotals(completed)) }} </h4>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class=" p-3">
                    <div class="columns is-mobile text-center">
                        <div class="column card is-one-third">
                            <p class="title is-3 has-text-"> {{  pending.length }} </p>
                            <h4 class="subtitle is-5 mb-0">Pending </h4>
                        </div>
                        <div class="column card">
                            <p class="title is-3 has-text-primary"> {{  completed.length }} </p>
                            <h4 class="subtitle is-5 mb-0">Delivered </h4>
                        </div>
                        <div class="column card ">
                            <p class="title is-3 has-text-"> {{  confirmed.length }} </p>
                            <h4 class="subtitle is- mb-0">Confirmed </h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-4 has-text-"> Orders </p>
                            <h4 class="subtitle is-5 mb-0">Total orders </h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right">
                            <h4 class="has-text-weight-medium title is-4 "> {{  completed.length }} </h4>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-4 has-text-primary"> Products </p>
                            <h4 class="subtitle is-5 mb-0">Total products </h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right">
                            <h4 class="has-text-weight-medium title is-4 "> {{ allProducts.length }} </h4>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-4 has-text-"> Categories </p>
                            <h4 class="subtitle is-5 mb-0">Total categories </h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right">
                            <h4 class="has-text-weight-medium title is-4 "> {{ getUser.categories.length }} </h4>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="false" class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-5"> Wallet </p>
                            <h4 class="subtitle is-5">Total </h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right	">
                            <h4 class="has-text-weight-medium">GHC{{ numFormat(getTotals(completed)) }}</h4>
                        </div>
                    </div>
                    <hr class="mt-3">
                    <div class="columns is-mobile">
                        <div class="column is-half">
                            <div class="">
                                <p class="title is-5"> Pay Outs </p>
                                <h4 class="subtitle is-5">GHC0.00</h4>
                            </div>
                        </div>
                        <div class="column is-flex is-justify-content-right">
                            <div class=" ">
                                <p class="title is-5"> Pay Ins </p>
                                <h4 class="subtitle is-5">GHC0.00</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- <MainFooter/> -->
    </div>
</template>

<script>

    import MainFooter from '../components/footer'
    import SideNav from '../components/sidenav'

    import { mapGetters, mapActions} from 'vuex'
    import wNumb from 'wnumb'

        
    export default {
        data(){ return { 
            format: wNumb({ decimals: 2, thousand: ",", prefix: '₵ ', }),
        }},
        name: "InsightPage",
        components: {
            // MainFooter,
            SideNav
        },
        computed: {
            ...mapGetters('auth', ['getUser']),
            ...mapGetters('orders', ['getOrders']),
            ...mapGetters('orders', ['pending']),
            ...mapGetters('orders', ['confirmed']),
            ...mapGetters('orders', ['completed']),
            ...mapGetters('orders', ['cancelled']),
            ...mapGetters('products', ['allProducts']),
        },
        mounted() {
            this.getProducts()
        },
        methods: {
            getTotals(obj){
               const sum  = obj. reduce((accumulator, object) => {
                    return accumulator + object.totalPrice;
                }, 0)

                return sum
            },
            async getProducts() {
                await this.$store.dispatch('products/getProducts', this.getUser.business)
                
            },
            numFormat(amt){
                return this.format.to(amt)
            },
        }
    }
</script>

<style lang="scss" scoped>
    // .card {
    //     border: 1px solid rgba(10, 10, 10, 0.1) !important;
    //     box-shadow: none;
    // }
</style>